import { Link } from "react-router-dom";
import style from "./index.module.css";

const ShowroomsList = ({ showrooms, isSingle }: ComponentPropsType) => {
  return (
    <div className={style.rooms_list}>
      <div className="row">
        {showrooms.map((showroom, index) => (
          <div
            key={index}
            className={`${style.rooms__single} ${
              isSingle ? "col-12" : "col-lg-3 col-sm-4 col-6"
            }`}
          >
            <Link to={showroom.link}>
              <div className={style.rooms__single_image}>
                <img src={showroom.image} alt="" />
              </div>
              <p>{showroom.name}</p>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShowroomsList;

type ComponentPropsType = {
  showrooms: {
    name: string;
    image: string;
    link: string;
  }[];
  isSingle?: boolean;
};
